export const bluebarJam = {
  id: "bluebarJam",
  link: "/#/recipes/recipes/bluebarJam",
  name: "Bluebar Jam",
  cuisine: "Unknown Rosharan",
  summary: "Blueberry jam, just like it sounds",
  inspiration: null,
  quantity: "6 half pints (6 cups)",
  time: "1 hour",
  notes:
    "While bluebar probably isn't exactly the same thing as blueberry, similarity in Rosharan names usually means some sort of link to the original. So at some point, bluebar reminded someone on Roshar of blueberries. This is a pretty standard blueberry jam recipe, though I've cut the sugar a bit, and increased the cook time to still get it to gel. The butter is to help reduce foaming. Any fat should work, so for a vegan option replace the butter with coconut or vegetable oil. The jam can be canned in glass jars, frozen in plastic containers, or refrigerated if you plan to eat it all within a week or so. I have not included a how-to on home canning here. If you want to learn how to can, I recommend going to official sources such as the USDA Complete Guide to Home Canning. I used frozen blueberries, though defrosted or fresh ones will work too.",
  quotes:
    "Bread and jam. A note, tied to one of the jars, read: Bluebar jam. If you like it, it means you're mysterious, reserved, and thoughtful. (The Way of Kings ch 39)",
  image:
    "https://jozomby-public.s3.amazonaws.com/recipes/blueberry-jam-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "blueberries",
          display: "10 cups blueberries"
        },
        {
          item: "dairy",
          display: "1/2 tsp butter"
        },
        {
          item: "sugar",
          display: "3 cups granulated sugar"
        },
        {
          item: "pectin",
          display: "1 package low-sugar-required pectin"
        }
      ]
    }
  ],
  steps: [
    "If using fresh or defrosted blueberries, crush or process in a food processor to a chunky pulp.",
    "Put crushed blueberries (or frozen whole blueberries) in a medium-sized pot. Add butter and sugar. Sprinkle pectin over the sugar.",
    "Mix everything together, bring to boil over high heat. If using frozen blueberries, make sure to stir deeply to keep the sugar from just sitting on the bottom and burning. Also, once the berries are no longer frozen, blend them with an immersion blender to a chunky liquid. Regardless, once the mixture is boiling, reduce heat to medium, then simmer for about 20 minutes until gelled.",
    "To tell when the mixture has hit the gel point, either use a cooking thermometer (gel point is 220 degrees Fahrenheit at sea level, and decreases with elevation) or dip a spoon in the boiling mixture, pop the spoon in the freezer for a minute to cool, then see if the jam on the spoon has hit a consistency that you like yet. You'll want to look for a skin forming over the spoon, and the jam not just being thickened, but gelled up and holding together.",
    "If you can the jam, leave 1/4 inch headspace and process for 10 minutes (longer at higher elevations).",
    "To freeze the jam, place the jam in plastic containers, and freeze."
  ]
}
